import { z } from "zod";
import { createEndpoint } from "../createEndpoint";
import type { HttpClient } from "../httpClient";

const UploadsResponseSchema = z.object({
    urls: z.array(z.string()),
});

export function createUploadsApi(http: HttpClient, baseUrl: string) {
    const uploadsBaseUrl = `${baseUrl}`;
    return {
        picture: createEndpoint<unknown, FormData>(http, 'POST', '/profile-picture', {
            base: uploadsBaseUrl,
            asFormData: true,
        }),

        uploads: createEndpoint<z.infer<typeof UploadsResponseSchema>, FormData>(http, 'POST', '/uploads', {
            base: uploadsBaseUrl,
            asFormData: true,
            responseSchema: UploadsResponseSchema,
        }),
    }
}

export type UploadsApi = ReturnType<typeof createUploadsApi>;

